export function larvaId(unitId: string | null, deviceId?: string): string {
    if (!unitId) unitId = 'unknown-unit';
    if (!unitId) unitId = 'unknown-device';
    return `larva_${unitId}_${deviceId}`;
}

export function larvaGlobalId(): string {
    return `larva_global`;
}
